import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { UserMyRadiant as User } from '../../../providers';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '../../../providers/resources/utility';
import { TabsPage } from '../../dashboard';
import { DrawerState } from 'ion-bottom-drawer';
import { DetailEmployeeActivity, DetailIdle } from "../index";
import { cmpDepartmentList } from '@src/components/departmentList/cmp';
import { Storage } from '@ionic/storage';
import { StaffIdle } from '@providers/activity';

@Component({
  selector: 'activity-idle-staff',
  templateUrl: 'page.html'
})
export class IdleStaff {

  shouldBounce = true;
  dockedHeight = 400;
  distanceTop = 57;
  drawerState = DrawerState.Bottom;
  states = DrawerState;
  minimumHeight = 0;
  contentDrawer = 'sort';

  filter = {
    medicalCheckup:'',
    idle :true,
  };
  sort = 'name';

  berita:any = '';
  loading : any;
  isLogin : any = 0;
  data = {
    employee:[],
    employee_filter : [],
    selected:{
      department:[]
    }
  };
  state = {
    searching : true,
    filter : false,
    skeleton : true,
  };
  
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.employee_id,
    // nik : this.userApi.data.NIK,
    // date_start : this.today.awalYmd,
    // date_end : this.today.akhirYmd,
    search : '',
  }
  fileTransfer: FileTransferObject = this.transfer.create();
  @ViewChild('widgetSearch') private searchBar: Searchbar;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private events        : Events,
    private modalCtrl     : ModalController,
    private storage       : Storage,
    public idleProvider   : StaffIdle
  ) {
    this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
  	};
    this.getEmployee();
  }

  showBottomSheet(content){
    this.hideBottomSheet();
    var cmp = document.getElementById("backdrop-drawer");
    if(cmp != null && cmp != undefined){
        cmp.style.display = "block";
    }
    setTimeout(() => {
      this.dockedHeight = (content == 'sort') ? 250 : 400;
    this.drawerState = DrawerState.Docked;
    this.contentDrawer = content;
    }, 100);
  }

  onFilterIdle(state){
    this.filter.idle = state;
    this.getEmployee(this.actFilter());
  }

  resetFilter(){
    this.state.skeleton = true;
    this.state.filter = false;
    this.filter.medicalCheckup = '';
    this.data.selected.department = [];
    this.data.employee_filter = [];
    this.parameter.search = '';
    setTimeout(() => {
      this.hideBottomSheet();
      this.state.skeleton = false;
    }, 500);
  }

  onFilterMedicalCheckup(state){
    if (state == this.filter.medicalCheckup) {
      this.filter.medicalCheckup = '';
    }else{
      this.filter.medicalCheckup = state;
    }
    this.actFilter();
  }
  onSort(state){
    this.sort = state;
  }

  previewSort(){
    this.hideBottomSheet();
    this.getEmployee();
  }

  hideBottomSheet(){
    this.drawerState = DrawerState.Bottom;
  }

  getEmployee(successCallback?:any){
    // this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.parameter['idle'] = this.filter.idle;
    this.parameter['sort'] = this.sort;
    // this.parameter['']
    this.state.skeleton = true;
    this.check_filter();
    this.idleProvider.getStafIdle(this.parameter).subscribe((resp?:any) => {
      if(resp.success){
        this.data.employee = resp.data;
        console.log(this.state,this.data.employee);
        try {
          // this.loading.dismiss();
          setTimeout(() => {
            this.state.skeleton = false;
          }, 500);
        } catch (error) {}
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        // this.loading.dismiss();
        successCallback();
        setTimeout(() => {
          this.state.skeleton = false;
        }, 500);
      } catch (error) {
        
      }
    }); 
  }
  eventHandler(keyCode) {
    if (keyCode == 13) {
      // this.onSearch();
      this.getEmployee(this.actFilter());
    }
  }
  
  onSearch(){
    this.getEmployee(this.actFilter()); 
  }
  
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

  detailActivity(data){
    this.nav.push(DetailIdle,{data:data});
  }

  removeSelectedDepartment(index){
    this.data.selected.department.splice(index,1);
    this.actFilter();
  }

  showListDepartment(){
    let me = this;
    this.loading = this.helper.showLoading("Loading data...");
    this.storage.get('departmentList').then((val) => {
      if (val) {
        try {
          this.loading.dismiss();
        } catch (error) {}
        this.trigerPopUpDepartment(val);
      }else{
        this.repositoryProvider.getDepartment().subscribe( (resp?:any) => {
          try {
            this.loading.dismiss();
          } catch (error) {}
          if (resp.success) {
            this.storage.set('departmentList', resp.data);
            this.trigerPopUpDepartment(resp.data);
          }
        });
      }
    });
  }

  trigerPopUpDepartment(data){
    let departmentModal = this.modalCtrl.create(cmpDepartmentList, {department:data,departmentSelected:this.data.selected.department,fiturSearching:true,title:"Select Department"}, {cssClass: 'select-modal',enableBackdropDismiss:false });
      departmentModal.onDidDismiss(department => {
        if (department) {
          this.data.selected.department = department;
          this.actFilter();
        }
      });
      departmentModal.present();
  }

  check_filter(){
    let mcu = this.filter.medicalCheckup;
    let dept = this.data.selected.department.length;
    if (dept == 0 && mcu != 'valid' && mcu != 'expired') {
      this.state.filter = false;
    }
  }

  actFilter(){
    let staff = this.data.employee;
    this.state.filter = true;
    this.state.skeleton = true;
    //coutn
    let selectedDept = this.data.selected.department.map( (row) => {
      return row['id'];
    });
    this.data.employee_filter = [];
    if (selectedDept.length > 0) {
      this.data.employee.forEach((employee,index) => {
        let check = selectedDept.indexOf(employee['department_id']);
        if (check !== -1) {
          this.data.employee_filter.push(employee);
        }
      });  
    }else{
      this.data.employee_filter = this.data.employee;
    }
    let mcu = this.filter.medicalCheckup;
    if (mcu == 'valid') {
      this.data.employee_filter = this.helper.searchArrayByValueFromArrayObject(this.data.employee_filter,'active','state_expired');
    }else if(mcu == 'expired'){
      this.data.employee_filter = this.helper.searchArrayByValueFromArrayObject(this.data.employee_filter,'expired','state_expired');
    }

    // if (this.parameter.search.length > 0) {
    //   this.data.employee_filter = this.helper.searchArrayByValueFromArrayObject(this.data.employee_filter,this.parameter.search,'Nm_Sertifikat');
    // }
      
    setTimeout(() => {
      this.state.skeleton = false;
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/idle/page.ts